import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiTypography from '@material-ui/core/Typography';

// Mapping between typo types and MUI Typography props
const typeProps = {
  adornment: {
    variant: 'body1',
    color: 'textSecondary',
  },
  adornment2: {
    variant: 'body2',
    color: 'textSecondary',
  },
  buttonLike: {
    variant: 'button',
    style: {
      lineHeight: 1.2,
    },
  },
  cardTitle: {
    variant: 'h6',
    color: 'inherit',
    style: {
      fontWeight: 400,
      lineHeight: 1.2,
    },
  },
  cardTitle2: {
    variant: 'h6',
    color: 'primary',
    style: {
      fontWeight: 500,
      lineHeight: 1.2,
      fontSize: 18,
    },
  },
  chipInfo: {
    variant: 'button',
    color: 'inherit',
    style: {
      fontSize: '1rem',
    },
  },
  dialogTitle: {
    variant: 'h6',
    color: 'inherit',
  },
  formHelperTitle: {
    variant: 'subtitle2',
    color: 'secondary',
    style: {
      fontSize: '1rem',
    },
  },
  homeTitle: {
    variant: 'subtitle1',
    color: 'inherit',
  },
  keyInfo: {
    variant: 'h3',
    color: 'inherit',
    fontWeight: 400,
  },
  keyInfo2: {
    variant: 'h4',
    color: 'inherit',
  },
  keyInfo3: {
    variant: 'h6',
    color: 'inherit',
  },
  keyInfo4: {
    variant: 'subtitle2',
    color: 'secondary',
  },
  menuBottomTitle: {
    variant: 'button',
    color: 'inherit',
  },
  menuTitle: {
    variant: 'h5',
    color: 'inherit',
  },
  selectHeader: {
    variant: 'subtitle2',
    color: 'secondary',
    style: {
      fontStyle: 'italic',
      lineHeight: '48px',
    },
  },
  subtitle: {
    variant: 'subtitle2',
    color: 'textSecondary',
  },
  subtitle2: {
    variant: 'subtitle2',
    color: 'secondary',
    style: {
      fontSize: '1rem',
    },
  },
  tableToolbarTitle: {
    variant: 'subtitle1',
    color: 'inherit',
  },
  infoItemLabel: {
    color: 'primary',
    style: {
      fontSize: 14,
      fontWeight: '400',
      letterSpacing: -0.5,
    },
  },
  infoItemSubtitle: {
    color: 'primary',
    style: {
      fontSize: 14,
      fontWeight: '600',
      letterSpacing: -0.5,
    },
  },
  infoItem: {
    color: 'primary',
    style: {
      fontSize: 16,
      letterSpacing: -0.5,
    },
  },
  infoItemBold: {
    color: 'primary',
    style: {
      fontSize: 16,
      fontWeight: '500',
      letterSpacing: -0.5,
    },
  },
  serviceFeeRuleItem: {
    variant: 'h6',
    color: 'textSecondary',
    fontWeight: 400,
  },
};

const Typography = ({ type, children, ...otherProps }) => {
  // Components props
  const typographyProps = typeProps[type];

  return (
    <MuiTypography {...typographyProps} {...otherProps}>
      {children}
    </MuiTypography>
  );
};

Typography.propTypes = {
  type: PropTypes.oneOf([
    'adornment',
    'adornment2',
    'buttonLike',
    'cardTitle',
    'cardTitle2',
    'chipInfo',
    'dialogTitle',
    'formHelperTitle',
    'homeTitle',
    'keyInfo',
    'keyInfo2',
    'keyInfo3',
    'keyInfo4',
    'menuBottomTitle',
    'menuTitle',
    'selectHeader',
    'subtitle',
    'subtitle2',
    'tableToolbarTitle',
    'infoItemLabel',
    'infoItemSubtitle',
    'infoItem',
    'infoItemBold',
    'serviceFeeRuleItem',
  ]).isRequired,
  children: PropTypes.node.isRequired,
};

export default React.memo(Typography);



// WEBPACK FOOTER //
// ./components/core/Typography.js